import React from 'react';
import { useTheme } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';

import { Flex } from '@ui-library/flex';
import { FlexCard } from '@ui-library/card';
import { BaseText, LargeText } from '@ui-library/typography';

import { useDesignVariant } from '../designVariantContext';

interface AccountManagementBaseProps {
  loading: boolean;
  title?: string;
}

export const AccountManagementBase: React.FC<AccountManagementBaseProps> = ({
  loading,
  title,
  children,
}) => {
  const theme = useTheme();
  const isNext = useDesignVariant() === 'next';

  const cardBorderColor = isNext ? theme.token.next.colorBorder : theme.token.colorBorderSecondary;
  const cardStyle = isNext
    ? { borderRadius: parseInt(theme.token.next.borderRadius, 10) }
    : undefined;

  return (
    <Flex flexDirection="column" gap="0.25rem">
      {title && (
        <Flex alignItemsCenter gap="0.25rem">
          {!isNext && <FontAwesomeIcon icon={regular('cloud')} color={theme.token.colorLink} />}
          <BaseText
            fontWeight={isNext ? undefined : 600}
            color={isNext ? theme.token.next.palette.grey700 : theme.token.colorText}
          >
            {title}
          </BaseText>
        </Flex>
      )}

      <FlexCard
        borderColor={cardBorderColor}
        style={cardStyle}
        flexDirection="row"
        alignItemsCenter
        padding={isNext ? 'padding' : 'paddingLG'}
        className="account-management-card"
      >
        {loading ? (
          <Flex gap="0.5rem" alignItemsCenter>
            <FontAwesomeIcon
              icon={regular('circle-notch')}
              color={isNext ? theme.token.next.palette.grey700 : theme.token.colorPrimaryBase}
              spin
            />
            {isNext ? (
              <BaseText color={theme.token.next.palette.grey700}>Loading accounts...</BaseText>
            ) : (
              <LargeText strong>Loading accounts...</LargeText>
            )}
          </Flex>
        ) : (
          children
        )}
      </FlexCard>
    </Flex>
  );
};
